/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type MultiSwapAcceptMutationVariables = Types.Exact<{
	input: Types.MultiSwapAcceptRequest;
}>;

export type MultiSwapAcceptMutation = {
	__typename?: "Mutation";
	multiSwapAccept:
		| {
				__typename?: "MultiSwapSuccessResponse";
				multiSwap: {
					__typename?: "MultiSwap";
					swapId: string;
					totalTargetAssetAmount: { __typename?: "CurrencyAmount"; value: string };
					multiSwapItems: Array<{
						__typename?: "MultiSwapItem";
						sourceTrade: {
							__typename?: "MultiSwapTrade";
							tradeId: string;
							assetId: string;
							wallet: { __typename?: "Wallet"; id: string };
							amountAsset: { __typename?: "CurrencyAmount"; value: string };
							feePercentage: { __typename?: "CurrencyAmount"; value: string };
							executionTime: { __typename?: "DateTime"; iso8601: string };
						};
						targetTrade: {
							__typename?: "MultiSwapTrade";
							tradeId: string;
							assetId: string;
							wallet: { __typename?: "Wallet"; id: string };
							amountAsset: { __typename?: "CurrencyAmount"; value: string };
							feePercentage: { __typename?: "CurrencyAmount"; value: string };
							executionTime: { __typename?: "DateTime"; iso8601: string };
						};
					} | null>;
					errorItems?: Array<{
						__typename?: "ErrorItem";
						assetId: string;
						error: {
							__typename?: "MultiSwapError";
							errorCode?: string | null;
							statusCode?: number | null;
							translationKey?: string | null;
						};
					} | null> | null;
				};
		  }
		| {
				__typename?: "SwapInProgressResponse";
				swapInProgress?: { __typename?: "SwapInProgress"; swapId: string } | null;
		  };
};

export const MultiSwapAcceptDocument = gql`
	mutation multiSwapAccept($input: MultiSwapAcceptRequest!) {
		multiSwapAccept(request: $input) {
			... on MultiSwapSuccessResponse {
				multiSwap {
					swapId
					totalTargetAssetAmount {
						value
					}
					multiSwapItems {
						sourceTrade {
							tradeId
							assetId
							wallet {
								id
							}
							amountAsset {
								value
							}
							feePercentage {
								value
							}
							executionTime {
								iso8601
							}
						}
						targetTrade {
							tradeId
							assetId
							wallet {
								id
							}
							amountAsset {
								value
							}
							feePercentage {
								value
							}
							executionTime {
								iso8601
							}
						}
					}
					errorItems {
						assetId
						error {
							errorCode
							statusCode
							translationKey
						}
					}
				}
			}
			... on SwapInProgressResponse {
				swapInProgress {
					swapId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class MultiSwapAcceptGQLService extends Apollo.Mutation<
	MultiSwapAcceptMutation,
	MultiSwapAcceptMutationVariables
> {
	document = MultiSwapAcceptDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
